module.exports = __webpack_public_path__ + "img/spinner.e5e9172f.gif";